import { z } from 'zod';
import { query } from '../../utils';
export const getUserInformation = query({
    method: 'GET',
    path: '/user-information',
    responses: {
        200: z.object({
            zapsBalance: z.number(),
            totalZapsEarned: z.number(),
            usdcBalanceInCents: z.number(),
        }),
    },
});
